import { format } from 'date-fns';

export type parsedFilterFieldType = {
    field: string;
    parsedValue: string;
    originalValue: any;
};

export const parseFilterFields = (
    filterFields: Array<{ field: string; value: any }>,
    localization: any,
    entityTypes: string[],
    users: Array<{ userId: string; userName: string }>
): parsedFilterFieldType[] => {
    return filterFields.map((filter) => {
        let parsedValue = '';

        switch (filter.field) {
            case 'entityTypes':
                if (Array.isArray(filter.value)) {
                    parsedValue = `Entity Types: ${filter.value.join(', ')}`;
                }
                break;

            case 'userIds':
                if (Array.isArray(filter.value)) {
                    const userNames = filter.value
                        .map(id => users.find(u => u.userId === id)?.userName || id)
                        .join(', ');
                    parsedValue = `Users: ${userNames}`;
                }
                break;

            case 'actions':
                if (Array.isArray(filter.value)) {
                    const actionLabels = filter.value.map(action => {
                        switch (action) {
                            case 'CREATE': return 'Created';
                            case 'UPDATE': return 'Updated';
                            case 'DELETE': return 'Deleted';
                            default: return action;
                        }
                    }).join(', ');
                    parsedValue = `Actions: ${actionLabels}`;
                }
                break;

            case 'searchTerm':
                parsedValue = `Search: "${filter.value}"`;
                break;

            case 'range':
                const rangeLabels: { [key: string]: string } = {
                    today: 'Today',
                    week: 'This Week',
                    month: 'Last 30 Days',
                    quarter: 'Last 3 Months',
                    year: 'Last Year'
                };
                parsedValue = `Range: ${rangeLabels[filter.value] || filter.value}`;
                break;

            case 'startDate':
                try {
                    parsedValue = `From: ${format(new Date(filter.value), 'MMM dd, yyyy')}`;
                } catch {
                    parsedValue = `From: ${filter.value}`;
                }
                break;

            case 'endDate':
                try {
                    parsedValue = `To: ${format(new Date(filter.value), 'MMM dd, yyyy')}`;
                } catch {
                    parsedValue = `To: ${filter.value}`;
                }
                break;

            default:
                parsedValue = `${filter.field}: ${filter.value}`;
        }

        return {
            field: filter.field,
            parsedValue,
            originalValue: filter.value
        };
    });
};

export const removeFilterItem = (
    filterToRemove: parsedFilterFieldType,
    currentFilters: Array<{ field: string; value: any }>
): Array<{ field: string; value: any }> => {
    return currentFilters.filter((filter) => filter.field !== filterToRemove.field);
};
